<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>新增课程</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <el-form ref="addForm" :model="addForm" :rules="addRules" label-width="140px">
        <el-row>
          <el-col :span="10">
            <el-form-item label="课程名称" prop="course.courseName">
              <el-input clearable v-model="addForm.course.courseName"></el-input>
            </el-form-item>
          </el-col>
           <el-col :span="10">
            <el-form-item label="关联课程" prop="course.relationCourseId">
              <el-select v-model="addForm.course.relationCourseId" clearable placeholder="请选择" filterable multiple>
                <el-option
                  v-for="(item,index) in relationCourseList"
                  :key="index"
                  :label="item.courseName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="课程形式" prop="course.form">
              <el-radio-group v-model="addForm.course.form">
                <el-radio :label="1">线上</el-radio>
                <el-radio :label="2">线下</el-radio>
                <el-radio :label="3">线上和线下</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="课程内容" prop="course.contentType">
              <el-radio-group v-model="addForm.course.contentType">
                <el-radio :label="1">图文</el-radio>
                <el-radio :label="2">视频</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="是否需要考试" prop="course.isExam">
              <el-radio-group v-model="addForm.course.isExam">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1" disabled>是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否必学" prop="course.isMust">
              <el-radio-group v-model="addForm.course.isMust">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="对应技能" prop="course.skillchoos">
              <el-select
                v-model="addForm.course.skillchoos"
                clearable
                multiple
                placeholder="请选择技能"
                filterable
              >
                <el-option
                  v-for="(item,index) in skillList"
                  :key="index"
                  :label="item.skillName"
                  :value="item.id+''"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="是否跟单" prop="course.isDocumentary">
              <el-select v-model="addForm.course.isDocumentary" clearable placeholder="请选择" filterable>
                <el-option
                  v-for="(item,index) in isDocumentaryType"
                  :key="index"
                  :label="item"
                  :value="index+''"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="是否公开课" prop="course.isOpenClass">
              <el-radio-group v-model="addForm.course.isOpenClass">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="课程状态" prop="course.state">
              <el-radio-group v-model="addForm.course.state">
                <el-radio :label="0">开启</el-radio>
                <el-radio :label="1">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
              <el-col :span="10">
            <el-form-item label="课程类型" prop="course.courseType">
              <el-select v-model="addForm.course.courseType" clearable placeholder="请选择" filterable @change="courseTypeChange">
                <el-option
                  v-for="(item,index) in courseType"
                  :key="index"
                  :label="item"
                  :value="index+''"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="课次分类" prop="categoryIdList">
              <el-select
                v-model="addForm.categoryIdList"
                clearable
                multiple
                placeholder="请选择分类"
                filterable
              >
                <el-option
                  v-for="(item,index) in categoryList"
                  :key="index"
                  :label="item.type"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="提示语">
              <el-tag
                v-for="(tag,index) in keywords"
                :key="index"
                closable
                type="primary"
                @close="handleClose(tag)"
              >{{ tag }}</el-tag>
              <el-input
                v-if="newKeywordVisible"
                ref="newKeywordInput"
                v-model="newKeyword"
                class="input-new-keyword"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              />
              <el-button v-else class="button-new-keyword" type="primary" @click="showInput">+ 增加</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="10">
            <el-form-item label="课程背景图片" prop="course.courseBackimg">
              <el-upload
                :action="uploadPath"
                :show-file-list="false"
                :on-success="uploadCourseImg"
                class="avatar-uploader"
                accept=".jpg, .jpeg, .png, .gif"
              >
                <img v-if="addForm.course.courseBackimg" :src="addForm.course.courseBackimg" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
              <!-- <span class="info">比例5:4</span> -->
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="课程缩略图片" prop="course.courseBackimgSamll">
              <el-upload
                :action="uploadPath"
                :show-file-list="false"
                :on-success="uploadCourseImgSmall"
                class="avatar-uploader"
                accept=".jpg, .jpeg, .png, .gif"
              >
                <img
                  v-if="addForm.course.courseBackimgSamll"
                  :src="addForm.course.courseBackimgSamll"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
              <!-- <span class="info">建议尺寸 430*430 课程列表页使用</span> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="addForm.course.contentType==2">
          <el-col :span="10">
            <el-form-item label="视频列表" prop="videoList">
              <el-select v-model="addForm.videoList" clearable placeholder="请选择" filterable multiple>
                <el-option
                  v-for="(item,index) in allVideoList"
                  :key="index"
                  :label="item.fileName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="课程简述">
              <el-input
                type="textarea"
                v-model="addForm.course.courseSketch"
                placeholder
                clearable
                :rows="3"
                style="width:700px;"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="addForm.course.contentType==1">
          <el-form-item label="课程图文内容">
            <editor v-model="addForm.course.courseContent" :init="editorInit" />
          </el-form-item>
        </el-row>

        <el-row>
          <el-col :span="10"></el-col>
          <el-col :span="10"></el-col>
        </el-row>
      </el-form>
      <div style="text-align:center;margin-top:20px;">
        <el-button type="primary" @click="saveCourse('addForm')">提交</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
import ajaxStorage from "@/script/api/storage.js";
import Editor from "@tinymce/tinymce-vue";
let vm;
export default {
  components: { Editor },
  data() {
    return {
      courseType: {
        0: "准入培训",
        1: "其他",
        2: "管理培训",
        3: "技能提升"
      },
      isDocumentaryType: {
        0: "否",
        1: "无薪跟单",
        2: "有薪跟单"
      },
      uploadPath: service.addFile + globalData.userInfo.userAccount,

      editorInit: {
        language: "zh_CN",
        height: 500,
        convert_urls: false,
        plugins: [
          "advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr image imagetools importcss insertdatetime link lists media nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount"
        ],
        toolbar: [
          "searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample",
          "hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen"
        ],
        images_upload_handler: function(blobInfo, success, failure) {
          const formData = new FormData();
          formData.append("createAccount", globalData.userInfo.userAccount);
          formData.append("file", blobInfo.blob());
          ajaxStorage
            .$ajaxAddFile(formData)
            .then(res => {
              success(res.data.data.fileUrl);
            })
            .catch(() => {
              failure("上传失败，请重新上传");
            });
        }
      },
        categoryList: [],
      skillList: [],
      allVideoList:[],
      relationCourseList: [],
      newKeywordVisible: false,
      newKeyword: "",
      keywords: [],
      addForm: {
        categoryIdList:[],
        course:{
          contentType:1,
          courseBackimg:'',
          courseBackimgSamll:'',
          courseContent:'',
          courseName: '',
          courseSketch:'',
          courseType: "",
          form: 1,
          isExam: 0,
          isDocumentary: '',
          isMust: 0,
        isOpenClass: 0,
        state: 0,
        relationCourseId:[],
        relationCourseIds:'',
         skillchoos:[],
        skillId: '',
        },


        videoList:[],



        // state: null,

      },
      addRules: {
        'course.courseBackimg': [
          { required: true, message: "课程背景图片不能为空", rigger: "blur" },
        ],
        'course.courseBackimgSamll': [
          { required: true, message: "课程缩略图片不能为空", rigger: "blur" },
        ],
        'course.courseName': [
          {
            required: true,
            message: "请输入课程名称",
            trigger: "blur"
          }
        ],
        'course.skillchoos': [
          {
            required: true,
            message: "请选择技能",
            trigger: "change"
          }
        ],
        'course.courseType': [
          {
            required: true,
            message: "请选择课程类型",
            trigger: "change"
          }
        ],
        'course.isDocumentary': [
          {
            required: true,
            message: "请选择是否跟单",
            trigger: "change"
          }
        ],
         categoryIdList: [
          {
            required: true,
            message: "请选择课次分类",
            trigger: "change"
          }
        ],
        videoList:[
          {
            required: true,
            message: "请选择视频",
            trigger: "change"
          }
        ],
      }
    };
  },

  created() {
      console.log(1);
    // this.getAllPostStation();
    this.getAllSkill();
    // this.getCategoryLevelTwo();
    this.getAllCourseList();
    this.getAllVideoList()

    // this.querySearch();
  },
  activated(){

  },
  beforeCreate() {
    vm = this;
  },
  methods: {
       getCategoryLevelTwo() {
      crmApi.$axiosGetCategoryLevelTwo({parentId:this.addForm.courseType}).then(res => {
        if (res.data.errno == 0) {
          this.categoryList = res.data.data;
        }
      });
    },
      getAllCourseList() {
      crmApi.$axiosGetAllCourseList().then(res => {
        if (res.data.errno == 0) {
          this.relationCourseList = res.data.data;
        }
      });
    },
    courseTypeChange(value){
        this.getCategoryLevelTwo();
    },
    getAllVideoList(){
      crmApi.$axiosFileossList({
       pageSize:1000,
       pageNum:1
      }).then(res => {
        if (res.data.errno == 0) {
          this.allVideoList = res.data.data.list;
        }
      });
    },
    uploadCourseImg: function(response) {
      this.addForm.course.courseBackimg = response.data.fileUrl;
      //   this.$refs["addForm"].validateField("courseBackimg");
    },
    uploadCourseImgSmall: function(response) {
      this.addForm.course.courseBackimgSamll = response.data.fileUrl;
      //   this.$refs["addForm"].validateField("courseBackimgSamll");
    },
    handleDel(index, row) {
      this.$confirm("是否停用课程?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          crmApi
            .$ajaxEmCourseDelCourse({
              id: row.id,
              updateUserId: globalData.userInfo.id
            })
            .then(res => {
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                this.querySearch();
              }
            });
        })
        .catch(() => {});
    },
    handleEditStation(row) {
      this.showAdd = true;
      this.addForm = {
        id: row.id,
        skillchoos: row.skillId.split(","),
        courseName: row.courseName,
        courseType: row.courseType + "",
        skillId: null,
        isDocumentary: row.isDocumentary + ""
      };
    },
    addCourse() {
      this.showAdd = true;
      this.addForm = {
        skillchoos: [],
        courseName: null,
        courseType: null,
        skillId: null,
        isDocumentary: null
      };
    },

    saveCourse(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
            if(this.addForm.course.contentType==1&&this.addForm.course.courseContent==''){
                this.$message.error('请编辑课程内容');
                return false;
            }
          this.addForm.course.skillId = this.addForm.course.skillchoos.join(",");
          this.addForm.course.relationCourseIds = this.addForm.course.relationCourseId.join(",");
          this.addForm.tipsList = this.keywords;
          crmApi.$axiosAddCourse(this.addForm).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("操作成功");
               this.$router.push({
                 path:'/workermanager/empowermentTrain/courseManager'
               });
            } else {
              this.$message.error(res.data.data);
            }
          });
        }
      });
    },

    //查询
    querySearch() {
      this.listQuery.pageSize = this.pageSize;
      this.listQuery.pageNum = this.currentPage;
      crmApi.$ajaxEmCourseGetPageList(this.listQuery).then(res => {
        if (res.data.errno == 0) {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        }
      });
    },
    getAllSkill() {
      crmApi.$ajaxEmCourseGetAllSkillDict().then(res => {
        if (res.data.errno == 0) {
          this.skillList = res.data.data;
        }
      });
    },
    handleClose(tag) {
      this.keywords.splice(this.keywords.indexOf(tag), 1);
      //   this.addForm.tipsList = this.keywords;
    },
    showInput() {
      this.newKeywordVisible = true;
      this.$nextTick(_ => {
        this.$refs.newKeywordInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const newKeyword = this.newKeyword;
      if (newKeyword) {
        this.keywords.push(newKeyword);
        //   this.addForm.tipsList = this.keywords;
      }
      this.newKeywordVisible = false;
      this.newKeyword = "";
    }
  }
};
</script>
<style scoped>
.el-select--small {
  width: 100%;
}
.input-new-keyword {
  width: 200px;
}

.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
.el-tag {
  margin-right: 12px;
}
>>> .avatar-uploader .el-upload {
  width: 145px;
  height: 145px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
>>> .avatar-uploader .el-upload img {
  width: 145px;
  height: 145px;
  object-fit: contain;
}
>>> .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}
</style>
